import { useMemo } from "react";

export function useFinancerEligibility(financiers, formData) {
  return useMemo(() => {
    if (!financiers || !formData) return [];

    const city = formData.city;
    const cibil = Number(formData.cibilScore);
    const dp = Number(formData.downpayment);

    if (!city || Number.isNaN(cibil) || Number.isNaN(dp)) return [];

    return Object.entries(financiers)
      .filter(([_, financer]) => {
        const v = financer.eligibility;
        if (!v) return true;

        if (v.minCIBIL !== undefined && cibil < v.minCIBIL) return false;
        if (v.maxCIBIL !== undefined && cibil > v.maxCIBIL) return false;

        if (Array.isArray(v.cities) && !v.cities.includes(city)) {
          return false;
        }

        if (v.downPayment) {
          const r = v.downPayment;
          if (r.min !== undefined && dp < r.min) return false;
          if (r.max !== undefined && dp > r.max) return false;
        }

        return true;
      })
      .map(([financerKey]) => financerKey);
  }, [financiers, formData.city, formData.cibilScore, formData.downpayment]);
}
